export const data = {
  cubes: [
    {
      id: "67cf4354-8007-4e9c-a457-b95a45ef1265",
      name: "Postgres",
      color: "white",
      labelText: "Postgres",
      position: [-1.7738929251537776, 0.25, -2.8362129720068117],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "90fd5edd-038a-4de8-810c-505595cca0f6",
      name: "Client",
      color: "white",
      labelText: "Client",
      position: [-1.8360119321360755, 0.25, 2.9044484919930307],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
      name: "Redis",
      color: "white",
      labelText: "Redis",
      position: [0.3722617691063155, 0.25, -1.1241245334501038],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "b674118a-c54d-440b-9dec-a68eb9cb1158",
      name: "Load Balancer",
      color: "white",
      labelText: "Load Balancer",
      position: [-1.6213218465502606, 0.25, 0.6518145977911649],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "bbe84385-3109-41bb-b491-a2c4f37a5206",
      name: "Resque Worker",
      color: "white",
      labelText: "Resque Worker",
      position: [1.1675750599836734, 0.25, -2.7504440375495425],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "e391d6a3-11a2-4aea-b757-d9b5a06ed90f",
      name: "S3",
      color: "white",
      labelText: "S3",
      position: [-3.666300676699565, 0.25, -3.0608924779553686],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
    {
      id: "eed9d168-22f8-4297-a9af-320b15aaf196",
      name: "Rails Server",
      color: "white",
      labelText: "Rails Server",
      position: [-1.6024515454922028, 0.25, -1.0884257163697724],
      rotation: [0, 0, 0, "XYZ"],
      scale: [1, 1, 1],
      sides: [
        {
          name: "front",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "back",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "left",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "right",
          value: "",
          fontSize: 0.1,
        },
        {
          name: "top",
          value: "",
          fontSize: 0.1,
        },
      ],
    },
  ],
  tubes: [
    {
      id: "0d3ccb1a-49b2-4799-b3fe-85b9d3841249",
      firstObject: {
        name: "Rails Server",
        uuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      },
      secondObject: {
        name: "S3",
        uuid: "e391d6a3-11a2-4aea-b757-d9b5a06ed90f",
      },
      firstObjectUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      secondObjectUuid: "e391d6a3-11a2-4aea-b757-d9b5a06ed90f",
      animations: [
        {
          fromUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
          toUuid: "e391d6a3-11a2-4aea-b757-d9b5a06ed90f",
          type: "pulse",
          orderNumber: "3",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "UPLOAD FILE",
            color: "yellow",
          },
        },
      ],
    },
    {
      id: "69221f75-4eee-44f5-8eb7-dd47bbdd896f",
      firstObject: {
        name: "Redis",
        uuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
      },
      secondObject: {
        name: "Resque Worker",
        uuid: "bbe84385-3109-41bb-b491-a2c4f37a5206",
      },
      firstObjectUuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
      secondObjectUuid: "bbe84385-3109-41bb-b491-a2c4f37a5206",
      animations: [
        {
          fromUuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
          toUuid: "bbe84385-3109-41bb-b491-a2c4f37a5206",
          type: "pulse",
          orderNumber: "6",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "JOB FAILED",
            color: "red",
          },
        },
      ],
    },
    {
      id: "7e36f949-0f86-4744-8656-034e4686e729",
      firstObject: {
        name: "Rails Server",
        uuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      },
      secondObject: {
        name: "Redis",
        uuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
      },
      firstObjectUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      secondObjectUuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
      animations: [
        {
          fromUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
          toUuid: "af3796c9-c77e-442f-8d27-3600cfdd6ac7",
          type: "pulse",
          orderNumber: "5",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "ENQUE",
            color: "blue",
          },
        },
      ],
    },
    {
      id: "90bb682f-a87f-42fc-a425-a661399de501",
      firstObject: {
        name: "Load Balancer",
        uuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
      },
      secondObject: {
        name: "Rails Server",
        uuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      },
      firstObjectUuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
      secondObjectUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      animations: [
        {
          fromUuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
          toUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
          type: "pulse",
          orderNumber: "2",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "POST request",
            color: "blue",
          },
        },
      ],
    },
    {
      id: "e36cdb8a-a9f3-4bb3-9e3f-14962691c3b6",
      firstObject: {
        name: "Rails Server",
        uuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      },
      secondObject: {
        name: "Postgres",
        uuid: "67cf4354-8007-4e9c-a457-b95a45ef1265",
      },
      firstObjectUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
      secondObjectUuid: "67cf4354-8007-4e9c-a457-b95a45ef1265",
      animations: [
        {
          fromUuid: "eed9d168-22f8-4297-a9af-320b15aaf196",
          toUuid: "67cf4354-8007-4e9c-a457-b95a45ef1265",
          type: "pulse",
          orderNumber: "4",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "SAVE RECORD",
            color: "green",
          },
        },
      ],
    },
    {
      id: "fedadffb-c612-4fbb-9a47-37cd62e5ddc7",
      firstObject: {
        name: "Client",
        uuid: "90fd5edd-038a-4de8-810c-505595cca0f6",
      },
      secondObject: {
        name: "Load Balancer",
        uuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
      },
      firstObjectUuid: "90fd5edd-038a-4de8-810c-505595cca0f6",
      secondObjectUuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
      animations: [
        {
          fromUuid: "90fd5edd-038a-4de8-810c-505595cca0f6",
          toUuid: "b674118a-c54d-440b-9dec-a68eb9cb1158",
          type: "pulse",
          orderNumber: "1",
          origin: {
            text: "GET",
            color: "yellow",
          },
          destination: {
            text: "ROUTE TRAFFIC",
            color: "blue",
          },
        },
      ],
    },
  ],
};
